/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_DisabledInputs */

const en_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const de_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const fr_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const es_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const it_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const nl_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const pl_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const fi_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const da_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

const sv_portal_scanner_disabled = /** @type {(inputs: Portal_Scanner_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Portal_Scanner_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_disabled = /** @type {((inputs?: Portal_Scanner_DisabledInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_DisabledInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_disabled(inputs)
	if (locale === "fr") return fr_portal_scanner_disabled(inputs)
	if (locale === "es") return es_portal_scanner_disabled(inputs)
	if (locale === "it") return it_portal_scanner_disabled(inputs)
	if (locale === "nl") return nl_portal_scanner_disabled(inputs)
	if (locale === "pl") return pl_portal_scanner_disabled(inputs)
	if (locale === "fi") return fi_portal_scanner_disabled(inputs)
	if (locale === "da") return da_portal_scanner_disabled(inputs)
	if (locale === "sv") return sv_portal_scanner_disabled(inputs)
	return en_portal_scanner_disabled(inputs)
});